import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import AppHeader from "../Comp/AppHeader";
import FooterNew from "../Comp/FooterNew";

const BladeKing = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Blade King - Delete Account</title>
        <meta
          name="description"
          content="Steps to delete your Blade King game account and remove all related data."
        />
      </Helmet>

      <AppHeader name="privacy" indexSlide={0} />

      <main className="bg-white min-h-screen pt-20">
        <div className="w-5/6 md:w-3/4 px-1 break-words md:px-0 m-auto text-gray-700 text-xl pb-20">
          <h1 className="mt-20 font-bold text-5xl text-gray-800">
            Blade King Account Deletion
          </h1>

          <p className="mt-8">
            You can choose to delete your game account and remove all related data collected during your use of our application.
          </p>

          <p className="mt-4 font-semibold text-red-600">
            Deleting your account will permanently delete your game progress, in-game currency, purchases and all other information related to the account. This action cannot be undone.
          </p>

          <h2 className="mt-10 text-gray-800 text-3xl font-bold">
            Follow these steps to delete your game account data permanently:
          </h2>

          <ol className="list-decimal pl-6 space-y-4 mt-6 text-gray-700">
            <li>Open the Blade King game.</li>
            <li>Tap Settings in the top-right corner.</li>
            <li>Select Save Your Progress.</li>
            <li>Tap Delete Account.</li>
            <li>Type "Confirm" and tap "Delete".</li>
            <li>Select Delete again to complete the process.</li>
          </ol>
        </div>
      </main>

      <FooterNew bgColor="#ff6200" />
    </>
  );
};

export default BladeKing;
